import script from "./ReservedBooksList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservedBooksList.vue?vue&type=script&setup=true&lang=js"

import "./ReservedBooksList.vue?vue&type=style&index=0&id=eac897ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eac897ce"]])

export default __exports__